import i18n from '@dinosband/bv-i18n'
import Vue from 'vue'
import { isPlatform } from '@ionic/core'
import { App } from '@capacitor/app'
import { debug } from '@dinosband/dbi-utils'
import { BvMainClientPlugin } from '@dinosband/bv-main-client/src/vue'
import { setMainStore, mainStore } from '@dinosband/bv-utils'
import { DataCacheIndexedDB } from '@dinosband/bv-cache'
import { initPictureCache, setApolloClientForPicture } from '@dinosband/bv-client-util'
// import { alertUserExpelled, alertUserSuspended, global } from '@/utils/core'

//-------------------------------------------------------------------
export async function initializeMainClient () {
  const startTick = Date.now()
  debug.log('<< initializeMainClient >>')

  const mainServer = process.env.VUE_APP_MAIN_SERVER || 'main.api.bizplat.app'
  const secureMain = mainServer.includes('bizplat.app') ? 's' : ''
  Vue.use(BvMainClientPlugin, {
    httpURI: `http${secureMain}://${mainServer}/graphql`,
    wsURI: `ws${secureMain}://${mainServer}/subscriptions`,
    restURI: `http${secureMain}://${mainServer}`,
    // httpURI: 'http://13.209.145.21:4000',
    // wsURI: 'ws://13.209.145.21:4000/graphql',
  })

  // registore mainStore to bv-utils
  setMainStore(Vue.prototype.$mainStore)

  const bvCache = await import('@dinosband/bv-cache')
  if (bvCache) {
    const thumbnailCache = new DataCacheIndexedDB<number, string>('bv-thumbnail-cache', 1000, 100)
    mainStore.setCaches(bvCache.messageCache, thumbnailCache, bvCache.rootMessageCache, bvCache.messageNotiCache, bvCache.failedMessageCache)
  }

  await mainStore.initialize(0, async (err: string) => {
    await Vue.prototype.$dbIon.dismissLoading()
    debug.error('Error in mainStore: ', err)
    if (err === 'read-user') {
      const isApp = isPlatform('hybrid')
      const retry = await Vue.prototype.$dbIon.yesNoAlert(
        i18n.tc('init.mainindex01'),
        i18n.tc('init.mainindex02'),
        i18n.tc('init.mainindex03'), isApp ? i18n.tc('init.mainindex04') : i18n.tc('common.close'),
      )
      if (retry) {
        mainStore.apollo.reconnect()
      } else {
        if (isApp) {
          App.exitApp()
        }
      }
    } else if (err === 'no-user') {
      await Vue.prototype.$dbIon.alert(i18n.tc('init.mainindex05'), i18n.tc('init.mainindex06'))
    } else if (err.startsWith && err.startsWith('invalid-user')) {
      const code = err.slice('invalid-user:'.length)
      debug.log('invalid-user: code = ', code)
      const penalty = code.split(':')[0]
      if (!mainStore.isUserPenaltyNotified(penalty)) {
        mainStore.setUserPenaltyNotified(penalty)
        await Vue.prototype.$dbIon.alert(`penalty: ${penalty}`)
        // if (code.startsWith('suspend')) {
        //   await alertUserSuspended(code, i18n.tc('init.mainindex07'))
        // } else {
        //   await alertUserExpelled(i18n.tc('init.mainindex07'))
        // }
        await mainStore.signOut()
        if (isPlatform('hybrid')) {
          App.exitApp()
        } else {
          Vue.prototype.$dbiRouter.resetAndGo('/tabs/mypage')
        }
      }
    }
    // Vue.prototype.$dbIon.alert('처리 중에 오류가 발생했습니다.')
  })

  mainStore.apollo.onReconnected(async () => {
    // await Vue.prototype.$dbIon.alert('Network Reconnected.')
  })

  // setApolloClientForPicture(mainStore.apollo)
  await initPictureCache()

  await mainStore.readUserGraphFromSettings()

  debug.log('--- END main.init-main-client ---', (Date.now() - startTick) / 1000)
}

